module.exports = __webpack_public_path__ + "img/64.cd467122.png";